import e from "react";
import r from "prop-types";

function t() {
  return t = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];

      for (var n in t) {
        Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
      }
    }

    return e;
  }, t.apply(this, arguments);
}

function n(e, r) {
  if (null == e) return {};

  var t,
      n,
      a = function (e, r) {
    if (null == e) return {};
    var t,
        n,
        a = {},
        o = Object.keys(e);

    for (n = 0; n < o.length; n++) {
      t = o[n], r.indexOf(t) >= 0 || (a[t] = e[t]);
    }

    return a;
  }(e, r);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);

    for (n = 0; n < o.length; n++) {
      t = o[n], r.indexOf(t) >= 0 || Object.prototype.propertyIsEnumerable.call(e, t) && (a[t] = e[t]);
    }
  }

  return a;
}

var a = ["as"];

function o(r, o) {
  if (null != r.as) {
    var l = r.as,
        f = n(r, a);
    return e.createElement(l, t({}, f, {
      ref: o
    }));
  }

  return null != r.href ? e.createElement("a", t({}, r, {
    ref: o
  })) : e.createElement("div", t({}, r, {
    ref: o
  }));
}

o.displayName = "InlineBox";
var l = e.forwardRef(o);
l.displayName = "Box", l.propTypes = {
  as: r.oneOfType([r.elementType, r.element, r.func]),
  href: r.string
};
export { l as default };